import { useWindowWidth } from '@acceso/design-system';
import { useEffect, useRef } from 'react';

type UseScrollElementRefProps = {
  selectedItemId: string | null;
};

export const useScrollElementRef = ({ selectedItemId }: UseScrollElementRefProps) => {
  const { width } = useWindowWidth();

  const segmentItemsRefs = useRef<{ [key: string]: HTMLElement | null }>({});

  useEffect(() => {
    if (!selectedItemId) return;
    const el = segmentItemsRefs.current[selectedItemId];
    if (!el) return;

    const scroll = () =>
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

    scroll();

    requestAnimationFrame(() => {
      scroll();
    });

    const timeoutId = setTimeout(() => {
      scroll();
    }, 120);

    return () => clearTimeout(timeoutId);
  }, [selectedItemId, width]);

  return {
    segmentItemsRefs,
  };
};
